import {Box, Button, Carousel, PigmentThemeProvider, Typography} from '@customink/pigment-react';
import React, {useEffect, useState} from 'react';
import {QueryClientProvider} from 'react-query';
import useRecentSavedDesign from '../hooks/queries/recentSaveDesign';
import queryClient from 'src/shared/queryClient';

const HOST = window.__ENV__ === 'production' ? 'https://www.customink.com' : 'https://www-master.staging.customink.com';
const CAROUSEL_HEIGHT = '230px';

const RecentSavedDesignInner = () => {
  const { data } = useRecentSavedDesign();
  const [slides, setSlides] = useState([]);

  const {
    front_design,
    back_design,
    name,
    product_name,
    product_color,
    updated_at,
    edit_url
  } = data || {};

  useEffect(() => {
    if (front_design) {
      const proofSlides = [
        <img src={`${HOST}${front_design}`} alt="Front" />,
        back_design && <img src={`${HOST}${back_design}`} alt="Back" />
      ].filter(Boolean);
      
      setSlides(proofSlides);
      
      const productFind = document.querySelector('.pc-Subcategories-section-product-card.product-find');
      if (productFind) {
        productFind.style.display = 'none';
      }
    }
  }, [front_design, back_design]);

  if (!slides.length) return null;

  const trackInteraction = (action) => {
    const category = 'catalog subcategory';
    const label = 'popular picks';
    
    CustomInk.Metrics.fireEvent(category, `${action} click`, label);
    window.dataLayer.push({
      event: 'interaction',
      interaction_category: category,
      interaction_action: `${action} click`,
      interaction_label: label,
      interaction_value: label
    });
  };

  const handleEditDesign = () => {
    trackInteraction('edit my design');
    window.open(`${HOST}${edit_url}`, '_blank');
  };

  const handleViewDesigns = () => {
    trackInteraction('view my designs');
    window.open(`${HOST}/account/designs`, '_blank');
  };

  return (
    <Box sx={{ maxWidth: 245}}>
      <Typography
        sx={{ 
          color: '#242424',
          fontSize: '24px',
          fontWeight: '700',
        }}
      >
        Your Latest Save
      </Typography>
      <Carousel
        sx={{
          marginTop: '0.75rem',
          '.keen-slider__slide': {
            backgroundColor: '#d8d8d8',
            borderRadius: '8px'
          }
        }}
        dots={false}
        sliderHeight={CAROUSEL_HEIGHT}
        slides={slides}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', paddingTop: '0.5rem'}}>
        <Typography variant="body1" sx={{fontWeight: 'bold', margin: '0.25rem 0'}}>{name}</Typography>
        <Typography variant="captionLarge" sx={{fontSize: '14px'}}>{product_name}</Typography>
        <Typography variant="captionLarge" sx={{fontSize: '14px'}}>{product_color} | Last Saved: {updated_at}</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: '0.5rem', flexDirection: 'column', paddingTop: '1rem'}}>
        <Button onClick={handleEditDesign}>Edit My Design</Button>
        <Button onClick={handleViewDesigns} variant="secondary">View My Designs</Button>
      </Box>
    </Box>
  );
};

const RecentSavedDesign = () => {
  return (
    <PigmentThemeProvider>
      <QueryClientProvider client={queryClient}>
        <RecentSavedDesignInner />
      </QueryClientProvider>
    </PigmentThemeProvider>
  );
};

export default RecentSavedDesign;
